import React, {useState, useEffect, useContext} from 'react';
import { fade, makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import LinearProgress from "@material-ui/core/LinearProgress";
import {RemittanceContext, devConsolelog} from '../../Utility';
import {StyledCircularProgress} from '../Commons/styledTabs';
import {THEME_PRIMARY_COLOR} from '../../Constants';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(0),
    cursor: 'pointer',

  },
  disabledRoot: {
    cursor: 'not-allowed'
  },
  hoverRoot: {
    '&:hover': {
      boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
      // transform: 'scale(1.03)'
    }
  },


  paperContent: {
    width: '100%',
    height: 'calc(100% - 20px)',
    // textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    '&> div': {
      margin: 'auto'
    }
  },
  progress: {
    height: 20,
    borderRadius: 3,
    '&>div': {
      backgroundColor: 'green'
    }
  },
  colorPrimary: {
    // '&>div': {
    //   backgroundColor: `${THEME_PRIMARY_COLOR}`
    // }
    backgroundColor: fade(`${THEME_PRIMARY_COLOR}`, 0.8)
  }
}));

export default ({data = {}, index, detailsLoading, disable, key}) => {
  const [showNotSaved, setShowNotSaved] = useState(false);
  const classes = useStyles();
  const {setSelectedTraveler} = useContext(RemittanceContext);
  // const {setViewSnackbar} = useContext(AppContext);
  let {
    name="", docsUpdated,
    passport_number, pancard_number
  } = data;

  let progressData = [
    "name",
    "passport_number",
    "passport_issue_date",
    "passport_expiry_date",
    "passport_issue_place",
  ]
  if(index === 0) {
    progressData.push("pancard_front");
    progressData.push("pancard_number");
  }

  // let fieldKeys = Object.keys(progressData);
  let noOfFieldsFilled = 0, totalFields = progressData.length;  //useRef(0);

  progressData.forEach(key => {
    console.log('progressPercentage travelerCard map ', key, data[key], totalFields);

    if(data[key] !== null && data[key] !== '') {
      devConsolelog('progressPercentage add field', key, index)
      noOfFieldsFilled = ++(noOfFieldsFilled);
    }
  })
  let progressPercentage = (noOfFieldsFilled/totalFields)*100;
  devConsolelog('progressPercentage tally ', noOfFieldsFilled, totalFields, `${progressPercentage}%`, key, index)
  if(progressPercentage >= 90) progressPercentage = 100;

  useEffect(() => {
    for(let key in docsUpdated) {
      if(docsUpdated[key]) {
        setShowNotSaved(true);
      }
    }
  }, [])

  const handleCardClick = () => {
    if(disable) return;
    else setSelectedTraveler({...data, index});
  }

  let DetailSpan = ({data}) => <span style={{color: `${THEME_PRIMARY_COLOR}`}}>{data}</span>
// Number((100/5)*(index+1))
  devConsolelog('travelerCard render ', noOfFieldsFilled, progressData.length, progressPercentage)
  return (<Paper key={key} className={`${classes.root} ${disable && classes.disabledRoot} ${!disable && classes.hoverRoot}`} onClick={handleCardClick}>
    <LinearProgress className={`${classes.progress} ${!disable && classes.colorPrimary}`} variant="determinate" value={progressPercentage} color="primary"/>
    <div className={classes.paperContent}>
      <div>
        {
          progressPercentage > 0
          ? (<>
            <Typography variant="h6" component="h3" align="center" color="textSecondary">Traveller {index + 1} {showNotSaved && <span style={{color: 'red'}}>(not saved!)</span>}</Typography>
            {index === 0 && <Typography variant="h6" component="h3" align="center" color="secondary">PAN is mandatory!</Typography>}
            {name && (<Typography component="p" color="textSecondary">Name: <DetailSpan data={name} /></Typography>)}
            {passport_number && (<Typography component="p" color="textSecondary">Passport Number: <DetailSpan data={passport_number} /></Typography>)}
            {pancard_number && (<Typography component="p" color="textSecondary">Pancard Number: <DetailSpan data={pancard_number} /></Typography>)}
          </>)
          : (<Typography variant="h6" component="h3"  color="textSecondary">
            Traveller {index + 1} {/** Number((100/5)*(index+1)) **/} {/** progressPercentage **/}
            {index === 0 && <Typography variant="h6" component="h3" align="center" color="secondary">PAN is mandatory!</Typography>}
            {detailsLoading && <StyledCircularProgress />}
          </Typography>)

        }
      </div>
    </div>
  </Paper>)
}
